import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.js';
import './index.css';

// Self-hosted ICT brand fonts — Roboto (body) + Roboto Condensed (headings)
// to match ict.co marketing, IctIdentity, CustomerPortal, SupportPortal,
// SnopPortal. @fontsource ships the woff2 files inside node_modules so
// Vite serves them from our own origin (fingerprinted), keeping the status
// page off the fonts.googleapis.com CDN — which matters most here since
// the status page is what people open when other things are broken.
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto-condensed/400.css';
import '@fontsource/roboto-condensed/700.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
